import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useUser } from '../useUser'
import { useAppSetting } from '../useAppSettings'
import { validateShipping } from '@ztechapps/common.utils'

export const useShippingAddressValidation = () => {
  const useResult = useUser()
  const tenantId = useResult?.user?.tenantId
  const { setting } = useAppSetting({ tenantId, appSettingKey: 'SHIP_RESTRICTED_ADDRESS' })

  const settingValue = React.useMemo(() => {
    if (!isEmpty(setting?.value)) return setting?.value?.split(',')
  }, [setting])

  const validate = ({ address }) => {
    const result = true

    if (!isEmpty(address) && !isEmpty(settingValue)) {
      validateShipping({ street1: address, restrictedAddressValue: settingValue })
    }

    return result
  }

  return { validate }
}
